export default "__VITE_ASSET__BX7BE0vu__"